import { FuseAnimate } from '@fuse';
import { Fab, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import classNames from 'classnames';
import React from 'react';
import { MdMenu } from 'react-icons/md';

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    },
    addButtonLookup: {
        bottom: 70,
    },
    divAcoesButton: {
        position: 'absolute',
        right: 20,
        bottom: 90,
        zIndex: 99,
    },
    divAcoesButtonLookup: {
        bottom: 140,
    },
});

class XAPPAcoesTela extends XAPPComponent {

    state = {
        revelarAcoes: false
    }

    revelarAcoes = () => {
        this.setState({ revelarAcoes: !this.state.revelarAcoes })
    }

    render() {
        const { classes, children, isLookup } = this.props;
        const { revelarAcoes } = this.state;

        return (
            <React.Fragment>
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <Fab
                        color="primary"
                        aria-label="verAcoes"
                        className={classNames(classes.addButton, (isLookup) && classes.addButtonLookup)}
                        onClick={() => this.revelarAcoes()}
                    >
                        <MdMenu className="text-24 text-white" />
                    </Fab>
                </FuseAnimate>
                {revelarAcoes &&
                    <FuseAnimate delay={300}>
                        <div className={classNames(classes.divAcoesButton, 'flex-col max-w-56', (isLookup) && classes.divAcoesButtonLookup)}>
                            {children}
                        </div>
                    </FuseAnimate>
                }
            </React.Fragment>
        )
    };
}

export default withStyles(styles, { withTheme: true })(XAPPAcoesTela);
